export default function Vipbeachtennis() {
  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg">
      <div className="flex items-center gap-3 mb-4">
        <span className="text-3xl">🏆</span>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Vip beach tennis</h1>
      </div>
      <p className="text-gray-600 dark:text-gray-400 mb-6">
        Bem-vindo à aba VIP! Esta seção contém as métricas exclusivas de beach tennis VIP.
      </p>

      <div className="grid grid-cols-2 gap-4 mt-6">
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-900/10 p-6 rounded-lg border-l-4 border-blue-500">
          <p className="text-sm text-gray-600 dark:text-gray-400">Clientes VIP</p>
          <p className="text-3xl font-bold text-blue-600 dark:text-blue-400 mt-2">24</p>
          <p className="text-xs text-gray-600 dark:text-gray-400 mt-2">↑ 12% vs mês anterior</p>
        </div>
        <div className="bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/30 dark:to-green-900/10 p-6 rounded-lg border-l-4 border-green-500">
          <p className="text-sm text-gray-600 dark:text-gray-400">Receita VIP</p>
          <p className="text-3xl font-bold text-green-600 dark:text-green-400 mt-2">R$ 45.600</p>
          <p className="text-xs text-gray-600 dark:text-gray-400 mt-2">↑ 8% vs mês anterior</p>
        </div>
        <div className="bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-900/30 dark:to-purple-900/10 p-6 rounded-lg border-l-4 border-purple-500">
          <p className="text-sm text-gray-600 dark:text-gray-400">Ticket VIP Médio</p>
          <p className="text-3xl font-bold text-purple-600 dark:text-purple-400 mt-2">R$ 1.900</p>
          <p className="text-xs text-gray-600 dark:text-gray-400 mt-2">Principal fonte: Beach Tennis</p>
        </div>
        <div className="bg-gradient-to-br from-orange-50 to-orange-100 dark:from-orange-900/30 dark:to-orange-900/10 p-6 rounded-lg border-l-4 border-orange-500">
          <p className="text-sm text-gray-600 dark:text-gray-400">Taxa de Retenção</p>
          <p className="text-3xl font-bold text-orange-600 dark:text-orange-400 mt-2">94%</p>
          <p className="text-xs text-gray-600 dark:text-gray-400 mt-2">Acima da meta de 85%</p>
        </div>
      </div>

      <div className="mt-6 bg-gradient-to-r from-indigo-50 to-blue-50 dark:from-indigo-900/20 dark:to-blue-900/20 p-4 rounded-lg border border-indigo-200 dark:border-indigo-700">
        <h3 className="font-bold text-gray-900 dark:text-white mb-2">🎯 Principais Eventos VIP</h3>
        <ul className="text-sm text-gray-600 dark:text-gray-400 space-y-1">
          <li>✓ Campeonato Beach Tennis - Junho/2026</li>
          <li>✓ Workshop de técnicas avançadas - Julho/2026</li>
          <li>✓ Eventos exclusivos mensais para clientes VIP</li>
        </ul>
      </div>
    </div>
  )
}
